// extracted by mini-css-extract-plugin
export var conversationListItem = "_xt-2";
export var fullBleedList = "_xt-3";
export var messageText = "_xt-1";
export var previewText = "_xt-0";